import React from 'react'
import tw from 'twin.macro'
import styled from 'styled-components'
import { ImageIcon } from '@components/Icons'

function FileUploadChanger(props) {
  const { inputId } = props

  const fileInputClicked = () => {
    if (!inputId) return
    const fileInputRef = document.getElementById(inputId) as HTMLInputElement
    fileInputRef.value = null
    fileInputRef.click()
  }

  return (
    <Container onClick={fileInputClicked}>
      <ImageIcon />
    </Container>
  )
}

export default FileUploadChanger

const Container = styled.div`
  ${tw`flex items-center justify-center cursor-pointer rounded-full`}
  background: white;
  width: 36px;
  height: 36px;
  svg {
    ${tw`text-gray-600`}
    width: 20px;
    height: 20px;
  }
`
